import React from 'react'
import { object } from 'prop-types'

import { QRCodeSVG } from 'qrcode.react'
// import Barcode from 'react-barcode'

import GlobalStyles from '@mui/material/GlobalStyles'
import { styled } from '@mui/material/styles'

import toPrintData from './toPrintData.js'

// THE ONE RULE THAT HAS TO STAY GLOBAL. `@page` describes the sheet itself
// rather than any element on it, so there is nothing to scope it to. This is
// what makes an invoice come out 58mm wide instead of on A4.
const printPage = {
  '@media print': {
    '@page': {
      size: '58mm 297mm',
    },
  },
}

// What the old sheet declared with JSS `@global` -- h5, h6, h6 span, svg --
// now scoped under each paper below.
//
// SCOPING IS NOT A COMPROMISE HERE, it is the fix. Every element those rules
// were written for is inside one of the two papers; being global only meant
// they also restyled every other h5, h6 and svg in the app for as long as an
// invoice was on screen. The class rules follow them in so that one styled
// root carries the whole sheet.
const paper = {
  width: '58mm',
  textAlign: 'center',

  '& h5': {
    font: 'bold 19px/1.2 Verdana',
    margin: 0,
  },
  '& h6': {
    font: 'bold 22px/1 Verdana',
    margin: 0,
  },
  '& h6 span': {
    fontSize: 30,
    verticalAlign: -3,
    fontFamily: 'Times New Roman',
  },
  '& svg': {
    display: 'block',
    margin: 2,
  },

  '& .align_left': {
    textAlign: 'left',
    marginLeft: 20,
  },
  '& .trade_info': {
    font: 'bold 13px/1.3 naomal, serif',
  },
  '& .code': {
    margin: '5px 5px',
  },
  '& .barcode': {
    margin: '5px auto',
  },
  '& .barcode_font': {
    fontFamily: "'Libre Barcode 39', cursive",
    fontSize: 18,
  },
  '& .half': {
    width: '50%',
    display: 'inline-block',
    float: 'left',
  },
  '& .detail': {
    font: 'bold 13px/1.3 naomal, serif',
    textAlign: 'left',
    verticalAlign: 'top',
    borderCollapse: 'collapse',
    width: '90%',
    margin: '5px',
    '& td': {
      verticalAlign: 'top',
    },
  },
  '& .itemName': {
    wordBreak: 'break-all',
  },
  '& .itemSubtotal': {
    textAlign: 'right',
  },
  '& .amount td': {
    borderTop: '1px solid black',
  },
}

const InvoicePaper = styled('div')(paper)

const DetailPaper = styled('div')({
  ...paper,
  borderTop: '1px dashed black',
  marginTop: '20px',
  paddingTop: '20px',
})

function Invoice(props) {
  const {
    doc: { invoiceOfPrinting },
  } = props

  if (!invoiceOfPrinting) return null

  // console.log(invoiceOfPrinting)
  const inv = toPrintData(invoiceOfPrinting)
  const ifPrintDetail = !!inv.buyerId

  return (
    <React.Fragment>
      <GlobalStyles styles={printPage} />
      <link
        href="https://fonts.googleapis.com/css?family=Libre+Barcode+39&display=swap"
        rel="stylesheet"
      />
      <InvoicePaper>
        <div>
          <img style={{ width: '90%' }} src="invoiceLogo.png" alt="禾宏文化" />
        </div>
        <h5>電子發票證明聯</h5>
        <h6>
          <span>{inv.year}</span>年<span>{inv.month}</span>月
        </h6>
        <h6>
          <span>{inv.no}</span>
        </h6>
        <div className="trade_info align_left">
          <span>{inv.date}</span>
          <span style={{ marginLeft: 20 }}>{inv.declarationType}</span>
        </div>
        <div className="trade_info align_left">
          <div className="half">隨機碼 {inv.randomNo}</div>
          <div className="half">總計 {inv.totalAmount}</div>
        </div>
        <div className="trade_info align_left">
          <div className="half">{inv.sellerId}</div>
          <div className="half">{inv.buyerId}</div>
        </div>
        <div className="barcode">
          <div className="barcode_font">{inv.barcode}</div>
          <div className="barcode_font" style={{ marginTop: -9 }}>
            {inv.barcode}
          </div>
          <div className="barcode_font" style={{ marginTop: -9 }}>
            {inv.barcode}
          </div>
        </div>
        <div className="code">
          <div className="half">
            <QRCodeSVG value={inv.qrCode1} size={90} />
          </div>
          <div className="half">
            <QRCodeSVG value={inv.qrCode2} size={90} />
          </div>
          <br style={{ clear: 'both' }} />
        </div>
      </InvoicePaper>
      {/*
       */}

      {!ifPrintDetail ? null : (
        <DetailPaper>
          <h5>交易明細</h5>
          <table className="detail">
            <tbody>
              {invoiceOfPrinting.items.map((item, index) => (
                <tr key={index}>
                  <td className="itemName">
                    {item.description} * {item.quantity}
                  </td>
                  <td className="itemSubtotal">{item.amount}</td>
                </tr>
              ))}
              <tr className="amount">
                <td>應稅銷售額</td>
                <td className="itemSubtotal">{inv.taxSales}</td>
              </tr>
              <tr>
                <td>營業稅</td>
                <td className="itemSubtotal">{inv.tax}</td>
              </tr>
              <tr>
                <td>總計</td>
                <td className="itemSubtotal">{inv.totalAmount}</td>
              </tr>
            </tbody>
          </table>
        </DetailPaper>
      )}
      {/*
       */}
    </React.Fragment>
  )
}
Invoice.propTypes = {
  doc: object.isRequired,
}

export default Invoice
